export default __webpack_public_path__ + "static/News-Image-329334fa8b6b650b82434d0c766a12f7.jpeg";